<template>
  <VCard
    v-if="loading"
    flat
  >
    <VCardText>
      <AppPreloader />
    </VCardText>
  </VCard>
  <VCard
    v-else-if="error.errorMessage"
    class="flex" flat
  >
    <VRow
      no-gutters
      justify="center"
    >
      <VCol
        cols="12"
        justify-self="center"
      >
        <VCardText class="error--text">
          {{ error.errorMessage }}
        </VCardText>
      </VCol>
    </VRow>
  </VCard>
  <VResponsive
    v-else-if="interviewResolved"
    ref="responsive" :aspect-ratio="16/9"
  >
    <MSEWrapper
      :media-server-client="mediaServerClient"
      :backend-client="backendClient"
      :interview="interview"
      :interviewer="interviewer"
      :questions="questions"
      :token="token"
      :resumed="resume"
      @completed="completed"
      @stopped="$emit('stopped')"
      @interrupted="$emit('interrupted')"
    />
  </VResponsive>
</template>

<script>
import { mapState } from 'vuex';
import MSEWrapper from '@huntica/huntica-interview-module/src/components/MSEWrapper.vue';
import backendClient from '../../api';
import mediaServerClient from '../../mediaServerClient';
import AppPreloader from '../AppPreloader.vue';
import ApiMixin from '../../mixins/ApiMixin';
import { safeGet } from '../../functions';
import { interviewStatuses } from '../../enums';

export default {
  name: 'InterviewRecorder',
  components: {
    AppPreloader,
    MSEWrapper,
  },
  mixins: [ApiMixin],
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    interviewer: {
      type: Object,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
    resume: {
      type: Boolean,
      default: false,
    },
    vacancyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      backendClient,
      mediaServerClient,
      loading: false,
      interviewResolved: false,
      error: {},
      token: localStorage.getItem(`vacancy_${this.vacancyId}_current_candidate`),
    };
  },
  computed: {
    ...mapState('interview', { interview: state => state.data }),
    isRecorded() {
      return this.interview
        && safeGet(this.interview, ['publication', 'url']) !== null
        && this.interview.status === interviewStatuses.RECORDING;
    },
  },
  async created() {
    await this.resolveInterview();
    if (this.$vuetify.breakpoint.smAndDown) {
      this.$nextTick(() => {
        window.scrollTo({
          top: this.$refs.responsive.$el.getBoundingClientRect().top,
          behavior: 'smooth',
        });
      });
    }
  },
  methods: {
    async resolveInterview() {
      if (!this.candidate.interview) {
        await this.withApiErrorHandling(async () => {
          await this.$store.dispatch('interview/store', { candidateId: this.candidate.id });
        }, 'error', 'loading');
      } else {
        await this.withApiErrorHandling(async () => {
          await this.$store.dispatch('interview/fetch', { id: this.candidate.interview.id });
        }, 'error', 'loading');
      }

      if (this.interview && safeGet(this.interview, ['publication', 'url']) === null) {
        await this.withApiErrorHandling(async () => {
          await this.$store.dispatch('interview/startPublication', { id: this.interview.id });
        }, 'error', 'loading');
      } else if (this.isRecorded) {
        await this.withApiErrorHandling(async () => {
          await this.$store.dispatch('interview/continuePublication', { id: this.interview.id });
        }, 'error', 'loading');
      }

      this.interviewResolved = true;
    },
    async completed() {
      await this.withApiErrorHandling(async () => {
        await this.$store.dispatch('interview/stopPublication', { id: this.interview.id });
      }, 'error');
      this.$emit('completed');
    },
  },
};
</script>
